import { captureException } from '@sentry/vue';

const AUTHENTICATION_ERRORS_MESSAGE_REGEXP = /.* code (401|403)/;

const STALE_CHUNK_ERRORS_MESSAGE_REGEXPS = [
  /Failed to fetch dynamically imported module/,
  /Importing a module script failed/,
  /error loading dynamically imported module/,
  /Unable to preload CSS/,
];

const THIRD_PARTY_LIBRARY_ERRORS_REGEXPS = [
  /Cannot read properties of null \(reading 'naturalHeight'\)/,
];

export const IGNORED_SENTRY_ERRORS = [
  AUTHENTICATION_ERRORS_MESSAGE_REGEXP,
  ...STALE_CHUNK_ERRORS_MESSAGE_REGEXPS,
  ...THIRD_PARTY_LIBRARY_ERRORS_REGEXPS,
];

export const DENIED_SENTRY_URLS = [/cookielaw\.org/, /onetrust\.com/];

const NETWORK_ABORT_ERRORS_REGEXPS = [
  /Network Error/,
  /<no response>/,
  /Load failed/,
  /Failed to fetch/i,
  /NetworkError when attempting to fetch resource/,
];

export const isNetworkAbortError = (err: unknown): boolean => {
  const message = err instanceof Error ? err.message : String(err);
  return NETWORK_ABORT_ERRORS_REGEXPS.some((regexp) => regexp.test(message));
};

export const captureHandledError = (
  err: unknown,
  tags: { feature: string },
): void => {
  if (isNetworkAbortError(err)) {
    return;
  }

  captureException(err, { level: 'warning', tags });
};
